// extracted by mini-css-extract-plugin
export default {"results":"results_results__ATSRG","results-container":"results_results-container__u9ZCJ","results-list":"results_results-list__9eAfb","results-table":"results_results-table__3XA6D"};